import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as pushToDarwinActionCreators from '../actions/pushToDarwinActionCreators';
import * as interactionAnalyticsActionCreators from '../actions/interactionAnalyticsActionCreators';

const useOpenInDarwin = () => {
    const dispatch = useDispatch();

    const handleOpenInDarwin = useCallback(() => {
        dispatch(pushToDarwinActionCreators.openInDarwin());
        dispatch(interactionAnalyticsActionCreators.openInDarwinButton());
    }, [dispatch]);

    return handleOpenInDarwin;
};

export default useOpenInDarwin;
